import Reveal from "./Reveal";
import { LOCATIONS, mapsLink } from "../data/office";

function MapPinIcon({ className }) {
  return (
    <svg viewBox="0 0 48 64" className={className} aria-hidden="true">
      <ellipse cx="24" cy="60" rx="12" ry="3.5" fill="#000" opacity="0.25" />
      <path
        d="M24 2C12.4 2 3 11.2 3 22.6 3 38 24 58 24 58s21-20 21-35.4C45 11.2 35.6 2 24 2z"
        fill="#EA4335"
      />
      <path
        d="M24 2C12.4 2 3 11.2 3 22.6 3 38 24 58 24 58V2z"
        fill="#C5221F"
        opacity="0.35"
      />
      <circle cx="24" cy="22" r="8" fill="#fff" />
    </svg>
  );
}

export default function Locations() {
  return (
    <section id="localizacoes" data-testid="locations-section" className="relative bg-navy-900 py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal className="mx-auto max-w-2xl text-center">
          <p className="font-mono-meta text-[11px] uppercase tracking-[0.35em] text-gold-400">
            Onde estamos
          </p>
          <h2 className="font-display mt-5 text-4xl font-medium leading-tight text-cream sm:text-5xl">
            Nossas <em className="gold-text">localizações</em>
          </h2>
        </Reveal>

        <div className="mx-auto mt-14 grid max-w-4xl grid-cols-1 gap-6 md:grid-cols-2">
          {LOCATIONS.map((loc) => (
            <Reveal key={loc.label}>
              <a
                data-testid={`location-${loc.label.replace(/\s/g, "-").toLowerCase()}`}
                href={mapsLink(loc.query)}
                target="_blank"
                rel="noopener noreferrer"
                title="Abrir no Google Maps"
                className="group flex h-full items-center gap-5 rounded-2xl border border-gold-500/25 bg-navy-800 p-6 transition-colors duration-300 hover:border-gold-500/60"
              >
                <MapPinIcon className="h-16 w-12 shrink-0 transition-transform duration-300 group-hover:-translate-y-1" />
                <div>
                  <p className="font-mono-meta text-[11px] uppercase tracking-[0.25em] text-gold-400">
                    {loc.label} · {loc.city}
                  </p>
                  <p className="mt-1.5 text-sm leading-relaxed text-cream">{loc.address}</p>
                  <p className="mt-2 text-xs text-mist underline-offset-4 group-hover:text-gold-400 group-hover:underline">
                    Abrir no Google Maps
                  </p>
                </div>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
